<template>
  <div class="card card-custom gutter-b card-stretch card-shadowless bg-light">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          {{ $t('Dashboard.Locationofdevices') }}
        </span>
      </h3>
      <div class="card-toolbar">
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body pt-3 pb-0">
      <!--begin::Table-->
      
      <GmapMap :center='center' :zoom='12' ref="map" style='width:100%;  height: 400px;'>
        <GmapMarker v-if="hasUserLocation" :position="center" :zoom="1"
          :icon="{ url: require('../../../../../public/media/markers/man2.png') }" />
        <GmapMarker v-for="(m, index) in markers" :key="index" :position="m.location" :clickable="true" :draggable="true"
          :icon="{ url: require('../../../../../public/media/markers/bot.png') }" />
      </GmapMap>

      <!--end::Table-->
    </div>
    <!--end::Body-->
    <b-modal ref="map-denied" hide-footer title="Oops!">
      <div class="d-block text-center">
        The map feature requires permissions to your browser location, please enable location to locate the map properly.
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { UPDATE_USER_POSITION } from "@/core/services/store/profile.module"
export default {
  name: "suitch-list-device-location",
  data() {
    return {
      center: { lat: 45.508, lng: -73.587 },
      markers: [],
      hasUserLocation: false,
      show: "day",
    }
  },
  components: {
  },
  watch: {
    markers(markers) {
      if (markers.length >= 1) {
        const bounds = new window.google.maps.LatLngBounds();
        if (this.hasUserLocation) {
          bounds.extend(this.center);
        }
        for (let m of markers) {
          bounds.extend(m.location);
        }
        this.$refs.map.fitBounds(bounds);
      }
    }
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
  },
  mounted() {
    this.initMap();
  },
  methods: {
    getCachedPosition() {
      try {
        const cached = localStorage.getItem('suitch_user_position');
        if (cached) {
          const parsed = JSON.parse(cached);
          const age = Date.now() - parsed.timestamp;
          if (age < 10 * 60 * 1000) {
            return parsed;
          }
        }
      } catch (e) {
        // ignore parse errors
      }
      return null;
    },
    cachePosition(lat, lng) {
      localStorage.setItem('suitch_user_position', JSON.stringify({
        lat, lng, timestamp: Date.now()
      }));
    },
    initMap() {
      const cached = this.getCachedPosition();
      if (cached) {
        this.hasUserLocation = true;
        this.center = { lat: cached.lat, lng: cached.lng };
        this.fetchDevices(`${cached.lat},${cached.lng}`);
        return;
      }

      if (!navigator.geolocation) {
        this.fetchDevices(null);
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.hasUserLocation = true;
          this.cachePosition(position.coords.latitude, position.coords.longitude);
          this.center = {
            lat: parseFloat(position.coords.latitude),
            lng: parseFloat(position.coords.longitude),
          };
          this.fetchDevices(`${position.coords.latitude},${position.coords.longitude}`);
        },
        () => {
          this.hasUserLocation = false;
          this.fetchDevices(null);
        },
        { enableHighAccuracy: true, timeout: 10000 }
      );
    },
    fetchDevices(location) {
      this.$store.dispatch(UPDATE_USER_POSITION, { location }).then((data) => {
        this.setMarkers(data);
      });
    },
    setMarkers(data) {
      this.markers = data.map(item => ({
        ...item,
        location: {
          lat: parseFloat(item.location.lat),
          lng: parseFloat(item.location.lng),
        }
      }));
    },
  }
};
</script>
